import { VoicemailPlayButton } from "shared/components/VoicemailPlayButton";
import { prerecordedVoicemailsApi } from "api/prerecordedVoicemails";
import {
  describeVoicemailDrop,
  formatVoicemailClock
} from "shared/utils/voicemail-drop";
import type { LeadActivityVoicemailDrop } from "views/leads-id/types";

/**
 * The pre-recorded voicemail a teammate left on an outgoing call (CRM-1830),
 * with a Play button for the message the lead's voicemail box got.
 */
export const VoicemailDropActivityCard = ({
  callId,
  drop
}: {
  callId: number;
  drop: LeadActivityVoicemailDrop;
}) => (
  <div className="space-y-2">
    <p className="text-sm font-bold text-content-1000">
      {describeVoicemailDrop(drop)}
    </p>
    <div className="flex items-center gap-3 rounded-lg border border-alpha-100 px-3 py-2">
      <VoicemailPlayButton
        size="sm"
        loadUrl={async () =>
          (await prerecordedVoicemailsApi.leftOnCall(callId)).url
        }
        name={drop.name}
      />
      <p className="min-w-0 truncate text-xs font-medium text-content-1000">
        {drop.name} · {formatVoicemailClock(drop.duration_seconds)}
      </p>
    </div>
  </div>
);
